import { HeaderGasStation } from './HeaderWithFiltersDefault/HeaderWithFiltersDefault';
import { HeaderRetail } from './HeaderRetail/HeaderRetail';
import { SingleModeFilter } from './SingleMode/SingleModeHeader';

export const HEADER_STRATEGY_CONSTANTS = Object.freeze({
  RETAIL: 'retail',
  SINGLE_MODE: 'single_mode',
  DEFAULT: 'default'
})

const getHeaderStrategy = (tenant) => {
  switch (tenant) {
    case HEADER_STRATEGY_CONSTANTS.RETAIL:
      return HeaderRetail;

    case HEADER_STRATEGY_CONSTANTS.SINGLE_MODE:
      return SingleModeFilter
    default:
      return HeaderGasStation;
  }
};

export const HeaderWithFilters = ({ actions, ctx, uiState, mode = HEADER_STRATEGY_CONSTANTS.DEFAULT }) => {
  const StrategyComponent = getHeaderStrategy(mode);
  return <StrategyComponent actions={actions} ctx={ctx} uiState={uiState} />;
};